/* tslint:disable */
export enum EventState {
  Paused = 1,
  Public = 2,
  Storno = 3,
}

